export const LogoMark = ({ size = 40, accent = "#2563EB" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="40" height="40" rx="10" fill={accent} />
    <path
      d="M12 20C12 15.5817 15.5817 12 20 12C24.4183 12 28 15.5817 28 20"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20"
      stroke="rgba(255,255,255,0.55)"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="20" cy="20" r="3" fill="#ffffff" />
  </svg>
);

export const Logo = ({ size = 40, withWordmark = true, accent = "#2563EB", sub = "ERP Platform", dark = false }) => (
  <span className="inline-flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={size} accent={accent} />
    {withWordmark && (
      <span className="leading-none">
        <span className={`block text-lg font-bold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
          SynqSMC
        </span>
        <span className={`mt-0.5 block font-mono text-[10px] uppercase tracking-[0.28em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
          {sub}
        </span>
      </span>
    )}
  </span>
);
